import { render, staticRenderFns } from "./countDownMakeSentence.vue?vue&type=template&id=f7a6ccde&scoped=true"
import script from "./countDownMakeSentence.vue?vue&type=script&lang=js"
export * from "./countDownMakeSentence.vue?vue&type=script&lang=js"
import style0 from "./countDownMakeSentence.vue?vue&type=style&index=0&id=f7a6ccde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a6ccde",
  null
  
)

export default component.exports